// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    lng: 'en', // Default language
    fallbackLng: 'en', // Language to fallback to if translations not found
    interpolation: {
      escapeValue: false // React already escapes by default
    },
    resources: {
      en: {
        translation: {
          dialogFormAppLaunch: {
            dialogTitle: 'Join the waiting list to unlock early access',
            dialogContentText: 'Please enter your first name, last name, and email to receive updates:',
            dialogSubmittedTitle: 'Welcome to the inner circle 🔑',
            dialogSubmittedDescription: 'You’ve locked in your spot! We’ll be in touch before launch so you can be one of the first to experience SHEKR.',
          },
          banner1: 'Create stunning posts, tag products, and earn when people shop your recommendations—no extra effort.',
          welcome: 'Welcome to our App',
          firstName: 'First name',
          lastName: 'Last name',
          email: 'Email Address',
          submit: 'Submit',
          thankYou: 'Thank you for your submission!',
          footer: {
            description: 'The social media that gives back to its community',
            navigation: {
              communityMembers: {
                title: 'Community Members',
                earn: 'Earn',
                shopping: 'Shopping',
                discover: 'Discover',
                create: 'Create',
                transparency: 'Transparency'
              },
              brandPartners: {
                title: 'Brand Partners',
                conversion: 'Conversion',
                exposure: 'Exposure',
                engagement: 'Engagement',
                create: 'Create'
              },
              letsConnect: {
                title: "Let's Connect"
              }
            }
          },
          applyForAStore: 'Apply for a store',
          unclockEarlyAccess: 'Unlock early access'
        }
      },
      // Add more languages here
      fr: {
        translation: {
          welcome: 'Bienvenido a nuestra aplicación',
          firstName: 'Primer nombre',
          lastName: 'Apellido',
          email: 'Dirección de correo electrónico',
          submit: 'Enviar',
          thankYou: 'Thank you for your submission!'
        }
      },
      es: {
        translation: {
          welcome: 'Bienvenido a nuestra aplicación',
          firstName: 'Primer nombre',
          lastName: 'Apellido',
          email: 'Dirección de correo electrónico',
          submit: 'Enviar',
          thankYou: 'Thank you for your submission!'
        }
      }
    }
  });

export default i18n;
